// features/ups/modals/ConfirmDeleteModal.js
// Safety dialog for deleting an agency; requires typing the agency name and fires onConfirm only when matched.
import React, { useState } from 'react';
import { X } from 'lucide-react';

const inputClass =
  'w-full rounded-xl border border-app-border bg-app-card px-4 py-3 text-sm text-app-text outline-none transition placeholder:text-app-muted focus:border-app-primary focus:ring-2 focus:ring-app-primary/20';
const secondaryButtonClass =
  'rounded-xl border border-app-border bg-app-card px-4 py-2.5 text-sm font-semibold text-app-text transition hover:bg-app-surface disabled:cursor-not-allowed disabled:opacity-60';
const dangerButtonClass =
  'rounded-xl bg-red-600 px-5 py-2.5 text-sm font-bold text-white shadow-sm transition hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60';

export default function ConfirmDeleteModal({ isOpen, onClose, agency, onConfirm }) {
  const confirmationInputId = 'confirm-delete-agency-name';
  const [typed, setTyped] = useState('');
  const canDelete = typed.trim() === (agency?.name ?? '');

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/45 p-0 backdrop-blur-sm sm:items-center sm:p-4" onClick={onClose}>
      <div className="flex h-[70dvh] w-full flex-col overflow-hidden rounded-t-2xl border border-app-border bg-app-card text-app-text shadow-2xl sm:h-auto sm:max-h-[92dvh] sm:max-w-lg sm:rounded-2xl" onClick={e => e.stopPropagation()}>
        <div className="flex shrink-0 items-center justify-between gap-4 border-b border-app-border px-4 py-4 sm:px-5">
          <h3 className="text-lg font-semibold text-red-700">Delete agency</h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close delete agency modal"
            className="rounded-xl p-2 text-app-muted transition hover:bg-app-surface hover:text-app-text"
          >
            <X size={18} />
          </button>
        </div>
        <div className="min-h-0 flex-1 space-y-4 overflow-y-auto px-4 py-4 sm:px-5 sm:py-5">
          <p className="text-sm text-app-text">
            This will permanently delete <span className="font-semibold">{agency?.name}</span>.
            Type the agency name to confirm.
          </p>
          <label htmlFor={confirmationInputId} className="sr-only">Type the agency name to confirm deletion</label>
          <input id={confirmationInputId} name="agencyNameConfirmation" className={inputClass} value={typed} onChange={e => setTyped(e.target.value)} />
        </div>
        <div
          className="flex shrink-0 flex-wrap items-center justify-end gap-2 border-t border-app-border bg-app-surface px-4 py-3 sm:px-5 sm:py-4"
          style={{ paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom))' }}
        >
          <button type="button" onClick={onClose} className={secondaryButtonClass}>Cancel</button>
          <button type="button" disabled={!canDelete} onClick={onConfirm} className={dangerButtonClass}>
            Delete agency
          </button>
        </div>
      </div>
    </div>
  );
}
